export function getWorkflowLogEntryId(searchParams: URLSearchParams): string | null {
  return searchParams.get("entry");
}

export function setWorkflowLogEntry(searchParams: URLSearchParams, entryId: string): URLSearchParams {
  const next = new URLSearchParams(searchParams);
  next.set("tab", "workflow-log");
  next.set("entry", entryId);
  return next;
}

export function setWorkflowLogEntryId(searchParams: URLSearchParams, entryId: string): URLSearchParams {
  const next = new URLSearchParams(searchParams);
  next.set("entry", entryId);
  return next;
}
